import { useInject } from '@vk-hr-tek/core/ioc';
import { ValidationService } from '@vk-hr-tek/core/validation';
import { Box } from '@vk-hr-tek/ui/Box';
import { FormError, TextInput, Form } from '@vk-hr-tek/app-ui/form';
import { FormKnownValue, FormKnownValues } from '@vk-hr-tek/ui/form';
import { Link } from '@vk-hr-tek/ui/Link';
import { Redo } from '@vk-hr-tek/ui/Redo';
import { Callout } from '@vk-hr-tek/ui/Callout';
import { Typography } from '@vk-hr-tek/ui/Typography';

import { useDispatch, useSelector } from '@app/hooks';

import { Button } from '../../../segments';
import { LoginDto, LoginInitDto } from '../../../dto';
import {
  selectPhone,
  selectPassword,
  selectNotification,
  selectStatus,
  login,
  loginInit,
  redirectToSendInviteForPhone,
} from '../../../slice';
import { useGetAuthInstance } from '../../../hooks';

export const LoginFinish = () => {
  const dispatch = useDispatch();
  const validator = useInject(ValidationService);

  const phone = useSelector(selectPhone);
  const password = useSelector(selectPassword);
  const error = useSelector(selectNotification);
  const status = useSelector(selectStatus);
  const {
    button_color: buttonColor,
    button_text: buttonText,
    id,
  } = useGetAuthInstance();

  const onSubmit = (values: LoginDto) =>
    new Promise((resolve) => {
      dispatch(
        login({
          values: {
            ...values,
            authInstanceId: id,
          },
          actions: { resolve },
        }),
      );
    });

  const resendCode = () => {
    return new Promise((resolve) => {
      dispatch(
        loginInit({
          values: { phone, password, auth_instance_id: id } as LoginInitDto,
          actions: { resolve },
        }),
      );
    });
  };

  return (
    <div>
      <Form
        onSubmit={onSubmit}
        validate={(values) => validator.validate(values, LoginDto, ['form'])}
        render={({
          handleSubmit,
          submitting,
          pristine,
          hasValidationErrors,
          dirtySinceLastSubmit,
        }) => (
          <form onSubmit={handleSubmit}>
            <FormKnownValues>
              <FormKnownValue label="Номер телефона" value={phone} />
            </FormKnownValues>
            <Box mt="24">
              <TextInput
                name="code"
                label="Код подтверждения"
                placeholder="Введите код"
                type="number"
                inputMode="numeric"
                autocomplete="one-time-code"
                id="qaAuthLoginFinishCodeInput"
                testId="test-id-verify-code-input"
              />
            </Box>
            <Box mb="12">
              <Callout>
                <Typography color="text.light.primary" variant="body3">
                  Код поступит в MAX или придёт по СМС
                </Typography>
              </Callout>
            </Box>
            <Redo label="Отправить код повторно" action={resendCode} />
            <Box mt={{ xs: '32', md: '48' }}>
              <Button
                color={buttonColor && `#${buttonColor}`}
                disabled={pristine || hasValidationErrors}
                loading={submitting}
                testId="test-id-code-accept-button"
              >
                {buttonText || 'Войти в HR Tek'}
              </Button>
            </Box>
            {!dirtySinceLastSubmit && status && status === 'failed' && (
              <FormError error={error} />
            )}
            <Box mt={{ xs: '24', md: '16' }}>
              <Link
                onClick={() => dispatch(redirectToSendInviteForPhone())}
                size="small"
                variant="tertiary"
              >
                Я сменил телефон
              </Link>
            </Box>
          </form>
        )}
      />
    </div>
  );
};
